import { render } from "./GerenciamentoChavesFacial.vue?vue&type=template&id=9ef5a362&scoped=true"
import script from "./GerenciamentoChavesFacial.vue?vue&type=script&lang=js"
export * from "./GerenciamentoChavesFacial.vue?vue&type=script&lang=js"

import "./GerenciamentoChavesFacial.vue?vue&type=style&index=0&id=9ef5a362&scoped=true&lang=css"
import "./GerenciamentoChavesFacial.vue?vue&type=style&index=1&id=9ef5a362&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ef5a362"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QField from 'quasar/src/components/field/QField.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QInput,QSelect,QIcon,QPopupProxy,QDate,QBtn,QCard,QTable,QImg,QTr,QTd,QField});qInstall(script, 'directives', {ClosePopup});
